import React, { useEffect, useState } from 'react';
import { DATE_FORMAT, DATE_MASK } from '../../../../../../helpers';
import { DDatePicker } from '../../../inputs';
import { RhDefaultProps } from '../common/rh-default-props';
import { useController, useFormContext } from 'react-hook-form';
import { useRhCustomContext } from '../rh-form-wrapper';

interface IRhDatePickerProps extends RhDefaultProps {}

export const RhDateInput = ({
    name,
    label,
    helperText,
    disableGutters = false,
    onChange,
    disabled = false,
}: IRhDatePickerProps) => {
    const [dateValue, setDateValue] = useState<string | null>(null);

    const { disabled: disabledFromContext } = useRhCustomContext();

    const { control } = useFormContext();
    const { field, fieldState } = useController({
        name,
        control,
    });

    useEffect(() => {
        setDateValue(field.value);
    }, [field.value]);

    return (
        <DDatePicker
            views={['day']}
            mask={DATE_MASK}
            inputFormat={DATE_FORMAT}
            disableGutters={disableGutters}
            disabled={disabledFromContext || disabled}
            label={label}
            onChange={(val) => {
                field.onChange({ target: { value: val } });
                if (onChange) {
                    onChange(val);
                }
            }}
            inputRef={field.ref}
            value={dateValue}
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message || helperText || ''}
        />
    );
};
